import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import React__default from 'react';
import PropTypes from 'prop-types';
import { d as changeColorToClassName, L as Label, a as LabelTypography, b as LabelColors } from '../index-6420013c.js';
import '../stringSet-b60e9529.js';
var http = /https?:\/\//;
function LinkLabel(_ref) {
  var className = _ref.className,
    src = _ref.src,
    type = _ref.type,
    color = _ref.color,
    children = _ref.children;
  var url = http.test(src) ? src : "http://".concat(src);
  return /*#__PURE__*/React__default.createElement("a", {
    className: [].concat(_toConsumableArray(Array.isArray(className) ? className : [className]), ['sendbird-link-label', color ? changeColorToClassName(color) : '']).join(' '),
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
    // for mobile
    ,

    onTouchEnd: function onTouchEnd(e) {
      e.preventDefault();
      e.nativeEvent.stopImmediatePropagation();
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }, /*#__PURE__*/React__default.createElement(Label, {
    className: "sendbird-link-label__label",
    type: type,
    color: color
  }, children));
}
LinkLabel.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  src: PropTypes.string.isRequired,
  type: PropTypes.string,
  color: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.element)]).isRequired
};
LinkLabel.defaultProps = {
  className: '',
  type: '',
  color: ''
};
var LinkLabelTypography = LabelTypography;
var LinkLabelColors = LabelColors;
export { LinkLabelColors, LinkLabelTypography, LinkLabel as default };